import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import SettingsTabs from '../../components/common/SettingsTabs';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
function SettingsSmtp() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        MAIL_HOST: '',
        MAIL_DRIVER: '',
        MAIL_PORT: '',
        MAIL_USERNAME: '',
        MAIL_PASSWORD: '',
        MAIL_ENCRYPTION: '',
        MAIL_FROM_ADDRESS: '',
        MAIL_FROM_NAME: '',
    });
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [cancel, setCancels] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const response = await apiService.postRequest(`/admin/get-protected-settings?settings_type=smtp`);
                const generaldata = response.data;
                setFormData({
                    MAIL_HOST: generaldata.MAIL_HOST || '',
                    MAIL_DRIVER: generaldata.MAIL_DRIVER || '',
                    MAIL_PORT: generaldata.MAIL_PORT || '',
                    MAIL_USERNAME: generaldata.MAIL_USERNAME || '',
                    MAIL_PASSWORD: generaldata.MAIL_PASSWORD || '',
                    MAIL_ENCRYPTION: generaldata.MAIL_ENCRYPTION || '',
                    MAIL_FROM_ADDRESS: generaldata.MAIL_FROM_ADDRESS || '',
                    MAIL_FROM_NAME: generaldata.MAIL_FROM_NAME || '',
                });
            } catch (error) {
                console.error("Error fetching user data", error);
            }finally {
                setCancels(false);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [cancel]);
    // Clear specific errors when inputs are modified
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear the error for the changed field
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append('MAIL_HOST', formData.MAIL_HOST);
        data.append('MAIL_DRIVER', formData.MAIL_DRIVER);
        data.append('MAIL_PORT', formData.MAIL_PORT);
        data.append('MAIL_USERNAME', formData.MAIL_USERNAME);
        data.append('MAIL_PASSWORD', formData.MAIL_PASSWORD);
        data.append('MAIL_ENCRYPTION', formData.MAIL_ENCRYPTION);
        data.append('MAIL_FROM_ADDRESS', formData.MAIL_FROM_ADDRESS);
        data.append('MAIL_FROM_NAME', formData.MAIL_FROM_NAME);
        
        // if (formData.site_logo) {
        // }

        setBtnLoading(true);
        try {
            const response = await apiService.postRequest('/admin/save-smtp-settings', data);
            if (response && response.success === true) {
                // navigate('/user/member');
                toast(response.message || "Settings saved successfully!");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error adding user:', error);
        } finally {
            setBtnLoading(false);
        }
    };   
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Company Settings</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Company Settings <FontAwesomeIcon className='angleright' icon={faAngleRight} /> SMTP</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn my-5">
                        <SettingsTabs/>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center">
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                            <Grid size={{sm:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Type<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_DRIVER" value={formData.MAIL_DRIVER} onChange={handleInputChange}/>
                                    {errors.MAIL_DRIVER && <p style={{color:"red"}}>{errors.MAIL_DRIVER}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Mail Host<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_HOST" value={formData.MAIL_HOST} onChange={handleInputChange} />
                                    {errors.MAIL_HOST && <p style={{color:"red"}}>{errors.MAIL_HOST}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Mail Port<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_PORT" value={formData.MAIL_PORT} onChange={handleInputChange}/>
                                    {errors.MAIL_PORT && <p style={{color:"red"}}>{errors.MAIL_PORT}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Mail Username<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_USERNAME" value={formData.MAIL_USERNAME} onChange={handleInputChange}/>
                                    {errors.MAIL_USERNAME && <p style={{color:"red"}}>{errors.MAIL_USERNAME}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Mail Password<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_PASSWORD" value={formData.MAIL_PASSWORD} onChange={handleInputChange}/>
                                    {errors.MAIL_PASSWORD && <p style={{color:"red"}}>{errors.MAIL_PASSWORD}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Mail Encryption<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_ENCRYPTION" value={formData.MAIL_ENCRYPTION} onChange={handleInputChange}/>
                                    {errors.MAIL_ENCRYPTION && <p style={{color:"red"}}>{errors.MAIL_ENCRYPTION}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Mail From Address<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_FROM_ADDRESS" value={formData.MAIL_FROM_ADDRESS} onChange={handleInputChange}/>
                                    {errors.MAIL_FROM_ADDRESS && <p style={{color:"red"}}>{errors.MAIL_FROM_ADDRESS}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>Mail From Name<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="MAIL_FROM_NAME" value={formData.MAIL_FROM_NAME} onChange={handleInputChange}/>
                                    {errors.MAIL_FROM_NAME && <p style={{color:"red"}}>{errors.MAIL_FROM_NAME}</p>}
                                </Grid>
                                {errorsmessage && <p style={{ color: 'red' }}>{errorsmessage}</p>}
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container className="gap-3 my-3">
                            <button type='button' className='registersendbtn1' onClick={()=>setCancels(true)}>Cancel</button>
                                <button type="submit" className='registersendbtn2'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </form>
                    </>}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default SettingsSmtp
